import axios from "axios";
import moment from "moment-timezone";
import { ROLES } from "../constants";

export const paginate = (items, currentPage, totalPages) => {
  const startIndex = (currentPage - 1) * totalPages;
  return items.slice(startIndex).filter((_, index) => index < totalPages);
};

export const handleApiRejection = (error) => {
  if (axios.isAxiosError(error) && error.response) return error.response.data;

  return error;
};

export const convertDateTime = (dateTime, format = "YYYY-MM-DD") => {
  if (!dateTime) {
    return null;
  }

  if (process.env.NODE_ENV === "production") {
    // Database is 4 hours ahead. We convert to local time
    return moment
      .tz(dateTime, "America/Sao_Paulo")
      .clone()
      .tz(dateTime, "Africa/Lagos")
      .format(format);
  }

  return moment(dateTime).format(format);
};

export const formatUserRole = (userRole) => {
  const matchingRole = Object.values(ROLES).find(
    (role) => role.TEXT === userRole
  );
  if (matchingRole) return matchingRole.LABEL;

  return userRole;
};

export const formatCertificateNumber = (value) => {
  const cleanValue = value.replaceAll("/", "");

  if (cleanValue.length <= 2) {
    return cleanValue;
  }

  const firstTwoDigits = cleanValue.substring(0, 2).toUpperCase();
  if (cleanValue.length <= 4) {
    return firstTwoDigits + "/" + cleanValue.substring(2).toUpperCase();
  }

  const nextTwoDigits = cleanValue.substring(2, 4).toUpperCase();
  if (cleanValue.length <= 13) {
    return (
      firstTwoDigits + "/" + nextTwoDigits + "/" + cleanValue.substring(4, 13)
    );
  }

  return (
    firstTwoDigits +
    "/" +
    nextTwoDigits +
    "/" +
    cleanValue.substring(4, 13) +
    "/" +
    cleanValue.substring(13)
  );
};

export const mapDataToFormData = (data) => {
  const formData = new FormData();

  for (const key in data) {
    if (data[key]) {
      formData.append(key, data[key]);
    }
  }

  return formData;
};

export const getLetterHistoryUserName = (letter = {}) => {
  const senderRoleId = letter.SENDER_ROLE_ID?.toString?.();
  const externalRoleId = ROLES.EXTERNAL.VALUE?.toString?.();

  if (!senderRoleId) return "N/A"; // missing role ID

  if (senderRoleId === externalRoleId) {
    return letter.SENDER_ID?.toLowerCase?.() || "N/A";
  }

  console.log("letter", letter);

  return letter.SENDER_NAME || "N/A";
};
